import { useEffect, useState } from "react";
import AlimModalSamll from "./AlimModalSamll";

const ProfilePicToggle=({modalFunc,customPos})=>{
    useEffect(()=>{
        if(modalFunc!==undefined)
        {
            const profilePicModalHandler=()=>{
                modalFunc(true);
            }
            document.addEventListener("alim-pro-pic-modal-event",profilePicModalHandler);

            return()=>{
                document.removeEventListener("alim-pro-pic-modal-event", profilePicModalHandler);
            }
        }
    });

    return(
        <>
            <div className={`cam-btn ${customPos}`} title="Update profile pic" onClick={()=>{document.dispatchEvent(alimProPicModalEvent);}}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                </svg>
            </div>
        </>
    )
}

export default ProfilePicToggle;